import styled from 'styled-components';

import { DetailItem } from '@hero/molecules';

const RecipientHeader = styled.div`
  align-items: center;
  align-self: flex-start;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  gap: 8px;
  padding: 3px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const VerticalDivider = styled.div`
  align-self: center;
  background: var(--color-accent-secondary-weaker);
  height: 20px;
  width: 1px;
`;

const RecipientHeaderButton = styled.a`
  align-items: center;
  color: var(--color-green-500);
  cursor: pointer;
  display: flex;
  fill: var(--color-green-500);
  font-size: 14px;
  font-weight: 700;
  gap: 4px;
  justify-content: center;
  padding: 4px 16px;
  text-transform: uppercase;
`;

const RecipientBody = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${DetailItem?.S?.Wrapper} {
    width: 100%;
  }
`;

const RecipientVerificationDetails = styled.div``;

const AddNew = styled.div`
  align-items: center;
  color: var(--color-accent-primary-default);
  cursor: pointer;
  display: flex;
  gap: 13px;
  justify-content: center;
`;

const LoadingWrapper = styled.div`
  align-items: center;
  background-color: var(--color-neutral-t16);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9;
`;

export {
  AddNew,
  Content,
  LoadingWrapper,
  RecipientBody,
  RecipientHeader,
  RecipientHeaderButton,
  RecipientVerificationDetails,
  VerticalDivider
};
